export const UTC_OFFSET_MINUTES = 120;
export const APP_TIMEZONE = "Europe/Bratislava";